<template>
  <main>
    <div class="py-5 text-center" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-else>
      <!-- <button type="button" @click="test">Test</button> -->
      <div v-if="redeemFormEnabled">
        <player :mode="mode" v-if="$store.state.currentCode || testMode"></player>
        
        <section class="container my-5" v-else>
          <div class="row">
            <div class="col-12">
              <div class="embed-responsive embed-responsive-16by9 bg-dark text-white">
                <div class="embed-responsive-item d-flex flex-column justify-content-center">
                  <div class="card align-self-center">
                    <div class="card-body text-dark">
                      <redeem-form></redeem-form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div v-else>
        <player :mode="mode"></player>
      </div>

      <section class="container mt-4" v-if="qnaEnabled && $store.state.currentCode">
        <div class="row">
          <div class="col-12 col-md-4">
            <h3 class="font-weight-bold">If you have a question, please send it to us.</h3>
          </div>
          <div class="col-12 col-md">
            <form name="questionForm" @submit.prevent="sendQuestion">
              <div class="row">
                <div class="col-12 col-md">
                  <div class="form-group">
                    <input type="text" name="name" id="name" v-model="questionName" class="form-control" placeholder="Enter your email">
                  </div>
                </div>

                <div class="col-12 col-md">
                  <div class="form-group">
                    <textarea type="text" name="question" id="question" v-model="questionQuestion" class="form-control" placeholder="Enter your question" rows="5"></textarea>
                  </div>
                </div>

                <!-- <div class="form-group">
                  <vue-recaptcha :sitekey="recaptchaSiteKey" @verify="recaptchaVerified"></vue-recaptcha>
                </div> -->
              </div>

              <div class="d-flex justify-content-end">
                <div class="mr-4 text-success" v-if="questionThanks">
                  {{ questionThanks }}
                </div>
                <button type="submit" name="send" id="send" class="btn btn-sm btn-secondary" :disabled="!this.questionFormValid">Send question</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import Player from "@/components/player.vue"
  import RedeemForm from "@/components/redeem-form.vue"
  // import VueRecaptcha from "vue-recaptcha"

  export default {
    name: "home",
    // components: { Player, RedeemForm, VueRecaptcha },
    components: { Player, RedeemForm },
    data() {
      return {
        loading: true,
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
        recaptchaValid: false,
        settings: null,
        sending: false,
        questionName: null,
        questionQuestion: null,
        questionThanks: null,
        olarkTest: false
      }
    },
    computed: {
      testMode() {
        return new URLSearchParams(window.location.search).get("wearejaws")
      },
      qnaEnabled() {
        if(this.settings) { return this.settings.qnaEnabled }
        return false
      },
      redeemFormEnabled() {
        if(this.settings) { return this.settings.redeemFormEnabled }
        return false
      },
      mode() {
        if(this.testMode) { return "test" }
        if(this.settings) { return this.settings.mode }
        return "offline"
      },
      questionFormValid() {
        // return !this.sending && 
        //   (this.questionName && this.questionName.length > 0) &&
        //   (this.questionQuestion && this.questionQuestion.length > 0) &&
        //   (this.recaptchaValid)
        return !this.sending && 
          (this.questionName && this.questionName.length > 0) &&
          (this.questionQuestion && this.questionQuestion.length > 0)
      },
      ticketValid() {
        return ""
      }
    },
    methods: {
      // test() {
      //   let xhttp = new XMLHttpRequest()
      //   xhttp.onreadystatechange = function() {
      //     if (this.readyState == 4 && this.status == 200) {
      //       console.log(this)
      //     }
      //   }
      //   xhttp.open("POST", "http://localhost:5001/gbgco-vms2/europe-west1/api/v1/add_code", true)
      //   xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
      //   xhttp.send("code=glenn&authkey=qW4wmWvCPqDsVuF6HmRH")
      // },
      recaptchaVerified() {
        this.recaptchaValid = true
      },
      async sendQuestion() {
        if(!this.questionFormValid) { return false }
        this.sending = true

        await firebase.firestore().collection(`questions`).add({
          name: this.questionName,
          question: this.questionQuestion,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.questionQuestion = null
        this.questionThanks = "Thank you!"
        this.sending = false

        setTimeout(() => {
          this.questionThanks = null
        }, 2000)
      }
    },
    async mounted() {
      await this.$bind("settings", firebase.firestore().collection(`application`).doc(`settings`))

      let codeInUrl = new URLSearchParams(window.location.search).get("code")

      if(codeInUrl) {
        let codeRef = await firebase.firestore().collection(`codes`).doc(codeInUrl)
        let ticket = await codeRef.get()
  
        if(ticket.exists) {
          await codeRef.update({ currentUser: this.$store.state.currentUser.uid, used: true })
          this.$store.commit("setCurrentCode", { codeString: ticket.id })
        }
      }

      this.loading = false
    }
  }
</script>

<style lang="scss" scoped>
  .player-wrapper {
    position: relative;
  }
</style>